import { Button, StatusWidget } from '@revolut-internal/ui-kit'
import { FC } from 'react'

interface ErrorWidgetProps {
  title?: string
  description?: string
  onRetry?: () => void
}

export const ErrorWidget: FC<ErrorWidgetProps> = ({
  title = 'Something went wrong',
  description,
  onRetry,
}) => (
  <StatusWidget>
    <StatusWidget.Image
      image={{
        default: 'https://assets.revolut.com/assets/3d-images-v2/3D018.png',
        '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@2x.png',
        '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@3x.png',
      }}
    />
    <StatusWidget.Title>{title}</StatusWidget.Title>
    {description && <StatusWidget.Description>{description}</StatusWidget.Description>}

    {onRetry && (
      <StatusWidget.Actions>
        <Button elevated onClick={onRetry}>
          Retry
        </Button>
      </StatusWidget.Actions>
    )}
  </StatusWidget>
)
